'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'building';
var width = 384;
var height = 512;
var aliases = [127970,61687];
var unicode = 'f1ad';
var svgPathData = 'M16 16l0 480 128 0 0-112 0-16 16 0 64 0 16 0 0 16 0 112 128 0 0-480L16 16zM160 496l64 0 0-112-64 0 0 112zm-16 16L16 512 0 512l0-16L0 16 0 0 16 0 368 0l16 0 0 16 0 480 0 16-16 0-128 0-16 0-64 0-16 0zM80 232l64 0 8 0 0 8 0 64 0 8-8 0-64 0-8 0 0-8 0-64 0-8 8 0zm8 64l48 0 0-48-48 0 0 48zm144-64l8 0 64 0 8 0 0 8 0 64 0 8-8 0-64 0-8 0 0-8 0-64 0-8zm16 16l0 48 48 0 0-48-48 0zM80 104l64 0 8 0 0 8 0 64 0 8-8 0-64 0-8 0 0-8 0-64 0-8 8 0zm8 64l48 0 0-48-48 0 0 48zm144-64l8 0 64 0 8 0 0 8 0 64 0 8-8 0-64 0-8 0 0-8 0-64 0-8zm16 16l0 48 48 0 0-48-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBuilding = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;